import { esc } from '../ui/modal';
import { t } from '../ui/lang';
import { maskSecret } from './secret';
import { fetchClickerServers } from './farm-clicker-config';
import { showEditClickerServerModal } from './clicker-server-modal';
/** "Servers" clicker-settings tab — add / list / delete clicker servers. */
export async function renderServersTab(panel) {
    panel.innerHTML = `
        <div class="settings-section">
            <h3 class="settings-section__title">${t('clickertab.add_server')}</h3>
            <form class="settings-server-form" novalidate>
                <div class="modal__field">
                    <label>${t('common.name')}</label>
                    <input class="settings-input cs-name" type="text" autocomplete="off" placeholder="${t('clickertab.server_name_placeholder')}" required />
                </div>
                <div class="modal__field">
                    <label>${t('clickertab.host')}</label>
                    <input class="settings-input cs-host" type="text" autocomplete="off" placeholder="${t('clickertab.host_placeholder')}" required />
                </div>
                <div class="modal__field">
                    <label>${t('clickertab.salt')}</label>
                    <input class="settings-input cs-salt" type="text" autocomplete="off" placeholder="${t('clickertab.salt_placeholder')}" required />
                </div>
                <button type="submit" class="modal__submit" style="margin-top:12px">${t('clickertab.add_server')}</button>
            </form>
            <div class="settings-error modal__error cs-add-error" style="display:none"></div>
        </div>
        <div class="settings-section">
            <h3 class="settings-section__title">${t('clickertab.servers')}</h3>
            <div class="cs-list">${t('common.loading')}</div>
        </div>
    `;
    const form = panel.querySelector('.settings-server-form');
    const nameInput = panel.querySelector('.cs-name');
    const hostInput = panel.querySelector('.cs-host');
    const saltInput = panel.querySelector('.cs-salt');
    const addError = panel.querySelector('.cs-add-error');
    const listEl = panel.querySelector('.cs-list');
    const showAddErr = (msg) => { addError.textContent = msg; addError.style.display = 'block'; };
    form.addEventListener('submit', async (e) => {
        e.preventDefault();
        addError.style.display = 'none';
        const name = nameInput.value.trim();
        const host = hostInput.value.trim();
        const salt = saltInput.value.trim();
        if (!name) {
            showAddErr(t('clickertab.err_name_required'));
            return;
        }
        if (!host) {
            showAddErr(t('clickertab.err_host_required'));
            return;
        }
        if (!salt) {
            showAddErr(t('clickertab.err_salt_required'));
            return;
        }
        const btn = form.querySelector('.modal__submit');
        btn.disabled = true;
        try {
            const r = await fetch('/api/clicker/servers', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name, host, salt }),
            });
            if (!r.ok) {
                showAddErr((await r.json()).error ?? t('clickertab.err_failed_add_server'));
                return;
            }
            form.reset();
            void loadList();
        }
        catch {
            showAddErr(t('clickertab.network_error'));
        }
        finally {
            btn.disabled = false;
        }
    });
    async function loadList() {
        const servers = await fetchClickerServers();
        renderList(servers);
    }
    function renderList(servers) {
        if (servers.length === 0) {
            listEl.innerHTML = `<p class="settings-hint">${t('clickertab.no_servers')}</p>`;
            return;
        }
        const rows = servers.map((s) => `
            <tr data-id="${s.id}">
                <td>${esc(s.name)}</td>
                <td>${esc(s.host)}</td>
                <td title="${t('clickertab.hidden')}">${esc(maskSecret(s.salt ?? ''))}</td>
                <td class="cs-actions">
                    <button type="button" class="modal__submit cs-edit" data-id="${s.id}">${t('common.edit')}</button>
                    <button type="button" class="modal__submit modal__submit--danger cs-del" data-id="${s.id}" data-name="${esc(s.name)}">${t('common.delete')}</button>
                </td>
            </tr>
        `).join('');
        listEl.innerHTML = `
            <table class="access-matrix">
                <thead><tr><th>${t('common.name')}</th><th>${t('clickertab.host')}</th><th>${t('clickertab.salt')}</th><th></th></tr></thead>
                <tbody>${rows}</tbody>
            </table>
        `;
        listEl.querySelectorAll('.cs-edit').forEach((btn) => {
            btn.addEventListener('click', () => {
                const id = parseInt(btn.dataset['id'] ?? '', 10);
                const server = servers.find((s) => s.id === id);
                if (server)
                    showEditClickerServerModal(server, () => { void loadList(); });
            });
        });
        listEl.querySelectorAll('.cs-del').forEach((btn) => {
            let armed = false;
            btn.addEventListener('click', async () => {
                if (!armed) {
                    armed = true;
                    btn.textContent = t('common.confirm');
                    setTimeout(() => { armed = false; btn.textContent = t('common.delete'); }, 4000);
                    return;
                }
                btn.disabled = true;
                try {
                    const id = parseInt(btn.dataset['id'] ?? '', 10);
                    const r = await fetch(`/api/clicker/servers/${id}`, { method: 'DELETE' });
                    if (!r.ok) {
                        btn.disabled = false;
                        armed = false;
                        btn.textContent = t('common.delete');
                        return;
                    }
                    void loadList();
                }
                catch {
                    btn.disabled = false;
                }
            });
        });
    }
    void loadList();
}
